import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { StatusBadge, KIND_LABEL } from "./status";

const Row = ({ c, onChange }) => {
  const [text, setText] = useState("");
  const last = (c.history || []).filter((h) => h.reason && h.action !== "submit").slice(-1)[0];
  const act = async (path, body, ok) => {
    try { await api[path.method](path.url, body); toast.success(ok); onChange(); }
    catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };
  return (
    <li className="rounded-xl bg-stone-50 px-3 py-2" data-testid={`vol-claim-${c.contribution_id}`}>
      <div className="flex items-center gap-2 flex-wrap">
        <span className="font-bold text-sm text-stone-900">{KIND_LABEL[c.kind] || c.kind}</span>
        <StatusBadge status={c.status} testId={`vol-claim-status-${c.contribution_id}`} />
        <span className="ml-auto text-xs font-black text-stone-600 tabular-nums">{c.points} pts</span>
      </div>
      {c.ref?.title && <div className="text-[11px] text-stone-500 truncate">{c.ref.title}</div>}
      {last && <div className="text-[11px] text-stone-600 mt-1">Reviewer: “{last.reason}”</div>}
      {(c.status === "request_evidence" || c.status === "rejected") && (
        <div className="flex gap-2 mt-2">
          <input value={text} onChange={(e) => setText(e.target.value)}
            placeholder={c.status === "rejected" ? "Why should this be reconsidered?" : "Add the requested details"}
            className="flex-1 px-3 py-1.5 rounded-full border border-stone-200 text-xs" data-testid={`vol-claim-input-${c.contribution_id}`} />
          <button className="text-xs font-black px-3 rounded-full bg-stone-900 text-white" data-testid={`vol-claim-respond-${c.contribution_id}`}
            onClick={() => c.status === "rejected"
              ? act({ method: "post", url: `/civic/contributions/${c.contribution_id}/appeal` }, { reason: text }, "Appeal sent")
              : act({ method: "patch", url: `/civic/contributions/${c.contribution_id}/evidence` }, { note: text }, "Evidence added")}>
            {c.status === "rejected" ? "Appeal" : "Send"}
          </button>
        </div>
      )}
    </li>
  );
};

export const ContributionHistory = ({ items, onChange }) => (
  <div className="rounded-3xl bg-white border border-stone-200 p-5 mb-6" data-testid="vol-history">
    <h2 className="heading text-lg font-black text-stone-900 mb-3">My contributions</h2>
    {items.length === 0
      ? <div className="text-sm text-stone-400 py-4 text-center">Nothing submitted yet.</div>
      : <ul className="space-y-2">{items.map((c) => <Row key={c.contribution_id} c={c} onChange={onChange} />)}</ul>}
  </div>
);
